var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeaderboardPodiumBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 159,
    viewBox: "0 0 122 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -104,
    y: -104,
    width: 330,
    height: 367
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(52px)",
      clipPath: "url(#bgblur_0_4956_705_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 104,
    d: "M12 0.5H110C116.351 0.5 121.5 5.64873 121.5 12V158.5H0.5V12C0.5 5.64873 5.64873 0.5 12 0.5Z",
    fill: "#525252",
    fillOpacity: 0.2,
    stroke: "#BD2333"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_4956_705_clip_path",
    transform: "translate(104 104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5H110C116.351 0.5 121.5 5.64873 121.5 12V158.5H0.5V12C0.5 5.64873 5.64873 0.5 12 0.5Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderboardPodiumBg);
export default __webpack_public_path__ + "static/media/leaderboardPodiumBG.f29a0fe5068e13029ecb85f37c3f0b20.svg";
export { ForwardRef as ReactComponent };